var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTailedArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Normal/Tailed Arrow"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.8333 16.6666V6.52492L15.4917 11.1833L16.6667 9.99992L10 3.33325L3.33334 9.99992L4.50834 11.1749L9.16667 6.52492V16.6666H10.8333Z",
    fill: "#8E899F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTailedArrow);
export default __webpack_public_path__ + "static/media/tailed_arrow.9558fa7425f0b247ced99e7ce8e4ae4c.svg";
export { ForwardRef as ReactComponent };